// extracted by mini-css-extract-plugin
export default {"wrapper":"DesignerGrid-module__wrapper___8fcJ8","designerGrid":"DesignerGrid-module__designerGrid___rF3Wh"};